import Icon from '../components/Icon.vue'

Icon.register({
  database: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 73.1v45.7c0 40.3-100.3 73.1-224 73.1s-224-32.9-224-73.1v-45.7c0-40.3 100.3-73.1 224-73.1s224 32.9 224 73.1zM448 176v102.9c0 40.3-100.3 73.1-224 73.1s-224-32.9-224-73.1v-102.9c48.1 33.1 136.2 48.6 224 48.6s175.9-15.4 224-48.6zM448 336v102.9c0 40.3-100.3 73.1-224 73.1s-224-32.9-224-73.1v-102.9c48.1 33.1 136.2 48.6 224 48.6s175.9-15.4 224-48.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/database.js
// module id = 1255
// module chunks = 0